import {
    IWayPointCreationSingleVoyage,
    IWayPointCreationWithCorrectionsSingleVoyage
} from "@containers/singleVoyage/types/point";
import {getPointGeomCoordinatesFromLatLng} from "@helpers/geoJson/getPointGeomCoordinatesFromLatLng";

export const buildCreationWayPointsByPointsWithCorrection = (points: IWayPointCreationWithCorrectionsSingleVoyage[]): IWayPointCreationSingleVoyage[] => {
    if (!points?.length) {
        return []
    }
    const res: IWayPointCreationSingleVoyage[] = []
    let shapeOrdinal = 0;
    points.forEach((point, index) => {
        res.push({
            name: point.name,
            address: point.address,
            radius: point.radius,
            type: point.type,
            plannedOrdinal: index,
            plannedDeparture: point.plannedDeparture,
            plannedArrival: point.plannedArrival,
            geom: point.geom,
            id: point.id,
            status: point.status,
            shapeOrdinal,
            waypointTemplateId:point.waypointTemplateId,
        })
        shapeOrdinal++
        if (point.correctionWaypoints?.length > -1) {
            point.correctionWaypoints.forEach(({lat, lng, id}, index) => {
                res.push({
                    type: 'SHAPING_POINT',
                    geom: getPointGeomCoordinatesFromLatLng({
                        lat,
                        lng,
                    }),
                    id,
                    shapeOrdinal,
                    name: null,
                    address: null,
                    radius: null,
                    plannedOrdinal: null,
                    plannedDeparture: null,
                    plannedArrival: null,
                    status: null,
                    waypointTemplateId:null
                })
                shapeOrdinal++
            })
        }
    })
    return res
}